
















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Api from "../../api/index";
import { getCookie } from "@szgc/plt-core-v2";

@Component({
  name: "WbenFileList",
  components: {}
})
export default class WbenFileList extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  private dataAll!: any;

  @Prop({
    type: Boolean,
    default: true
  })
  private none!: any;

  private prefix: any = "";
  private processData: any = null;
  private fileList: any[] = [];

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      if (this.dataAll && this.dataAll.length && this.dataAll.length > 0) {
        this.fileList = this.dataAll;
      }
    }
  }

  /*下载附件*/
  downLoadFile(item: any) {
    let url: string = "";
    if (this.prefix) {
      url = `${this.prefix}/${Api.downLoadAtt}?attId=${item.attId}`;
    } else {
      url = `${window.location.origin}/${Api.downLoadAtt}?attId=${item.attId}`;
    }
    window.open(url, "_blank");
  }
}
